import React, {useEffect, useState} from "react";
import './Login.scss'
import BaseButton from "../BaseButton/BaseButton";
import BottomSheet from "../BottomSheet/BottomSheet";
import send from '../../Assets/Icons/send.svg'
import BaseInput from "../BaseInput/BaseInput";
import axios from "axios";
import {setUser} from "../../store/actions";
import {useDispatch} from "react-redux";
import Success from "../Success/Success";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../Loader/Loader";
import Error from "../Error/Error";
import {useError} from "../../hooks/useError";

interface Props {
    onValidate: () => void
    show: boolean
    onClose: () => void
}

const Login: React.FC<Props> = ({onValidate, show, onClose}: Props) => {
    const dispatch = useDispatch()
    const [email, setEmail] = useState<string>('')
    const [emailError, setEmailError] = useState<string | undefined>(undefined)
    const [mdp, setMdp] = useState<string>('')
    const [showSendMdpConfirm, setShowSendMdpConfirm] = useState<boolean>(false)

    const loader = useLoader()
    const error = useError()

    useEffect(() => {
        setEmailError(undefined)
    }, [email])

    const handleBtn = () => {
        if(email.length > 0 && mdp.length > 0) {
            loader.show()
            axios.post(`${process.env.REACT_APP_BART_URL}/users/login`, {email, mdp})
                .then(res => {
                    dispatch(setUser(res.data))
                    onValidate()
                })
                .catch(() => {
                    error.open('Mauvais email ou mot de passe')
                })
                .finally(loader.hide)
        }
    }

    const handleMdpClick = () => {
        if(email.length === 0) {
            setEmailError('Merci de rentrer votre email')
        } else {
            const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            if(regex.test(email)){
                loader.show()
                void axios.get(`${process.env.REACT_APP_BART_URL}/users/exist/${email}`)
                    .then((response) => {
                        loader.hide()
                        if(response.data) {
                            void axios.post(`${process.env.REACT_APP_BART_URL}/emails/send_reset_password_email/${email}`)
                            setShowSendMdpConfirm(true)
                        } else {
                            setEmailError("Cette adresse email ne possède pas de compte")
                        }
                    })

            } else {
                setEmailError("Merci de rentrer un email valide.")
            }
        }
    }

    return (
        <>
            {
                error.visible ? (
                    <Error show={error.visible} close={error.close} title={"Une erreur est survenue"} subTitle={error.message} />
                ) : (
                    <>
                        {
                            !showSendMdpConfirm ? (
                                <BottomSheet show={show} close={onClose}>
                                    <div className="login">
                                        <h1 className="login--title">Connexion à votre compte</h1>
                                        <p className="login--text">Veuillez saisir votre adresse mail ainsi que votre mot de passe associé au compte</p>
                                        <BaseInput title={"Email"} value={email} type={"email"} onChange={setEmail} className="login--input" errorTxt={emailError} />
                                        <BaseInput
                                            title={"Mot de passe"}
                                            helpTxt={"Votre mot de passe doit contenir 8 caractères minimum"}
                                            onChange={setMdp}
                                            value={mdp}
                                            type={"password"}
                                            className="login--input"
                                        />
                                        <p className="login--mdpOublie" onClick={handleMdpClick}>Mot de passe oublié ?</p>
                                        <BaseButton onClick={handleBtn} text="Connexion" className="login--btn"/>
                                    </div>
                                </BottomSheet>
                            ) : (
                                <Success
                                    show={showSendMdpConfirm}
                                    close={() => setShowSendMdpConfirm(false)}
                                    title={email}
                                    subTitle="Un email vous a été envoyé à cette adresse mail pour réinitialiser votre mot de passe. Veuillez consulter votre boite mail."
                                    icone={send}
                                    btnTxt="Fermer"
                                />
                            )
                        }
                        <Loader visible={loader.visible} />
                    </>
                )
            }
        </>
    )
}

export default Login
